import { CameraIcon } from 'lucide-react';
import { DetailInfo } from '@/screens/profile/_components/profile-card/profile-card.types.ts';

interface ProfileHeaderProps {
	detailInfo: DetailInfo;
	specialization: string;
	avatarChange: boolean;
	avatarChangeIsLoading: boolean;
	handleImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
	setShowProfileEditModal: (show: boolean) => void;
}

export const ProfileHeader = ({ detailInfo, avatarChange, avatarChangeIsLoading, handleImageUpload, setShowProfileEditModal, specialization }: ProfileHeaderProps) => {
	const {
		expert: { name, surname, profilePicture, id }
	} = detailInfo;

	return (
		<div className="profile-header">
			<button
				className="edit-button"
				onClick={() => setShowProfileEditModal(true)}
				aria-label="Edit profile">
				<i className="icons-pen" />
			</button>

			<div className="profile-image">
				<img
					src={profilePicture}
					alt={`${name} ${surname}`}
				/>
				{!avatarChangeIsLoading && avatarChange && (
					<>
						<button
							className="camera-icon"
							onClick={() => document.getElementById('photo-input')?.click()}
							aria-label="Upload profile picture">
							<CameraIcon />
						</button>
						<input
							id="photo-input"
							type="file"
							accept="image/*"
							onChange={handleImageUpload}
							className="hidden"
						/>
					</>
				)}
			</div>

			<div className="profile-info-column">
				<h1 className="profile-name">{`${name} ${surname}`}</h1>
				<div className="sub-info-column">
					<div className="profile-title">{specialization}</div>
				</div>
				<div className="sub-info-column">
					<div className="profile-title">Uzman ID: {id}</div>
				</div>
			</div>
		</div>
	);
};
